import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { UserFilter } from "services/organizationPortalClient";
import SelectAccessLevel from "./SelectAccessLevel";
import SelectStatusType from "./SelectStatusType";
import { CommonFilter, useIsFilterApplied } from "@knowfully/ui.common";
import SelectProfession from "components/SelectProfession";
import SelectLicense from "components/SelectLicense";

type UserFilterProps = {
  onChange: (filter: UserFilter) => void;
};

export default function UserPageFilter({ onChange }: UserFilterProps) {
  const [filter, setFilter] = useState({} as UserFilter);
  const isFilterApplied = useIsFilterApplied(filter, []);

  const onChangeInternal = (prop: keyof UserFilter, val: any) => {
    setFilter((prev) => ({ ...prev, [prop]: val }) as UserFilter);
  };

  // Auto-apply filters to parent on any change
  useEffect(() => {
    onChange(filter);
  }, [filter, onChange]);

  const clearFilter = () => {
    setFilter({} as UserFilter);
  };

  return (
    <CommonFilter
      searchText={filter.searchText}
      onSearchTextChange={(val: string | undefined) => onChangeInternal("searchText", val)}
      onClear={clearFilter}
      isFilterApplied={isFilterApplied}
    >
      <Grid item xs={12} sm={12} md={4}>
        <SelectProfession
          value={filter.professionIds ?? []}
          onChange={(ids) => onChangeInternal("professionIds", ids)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <SelectLicense
          value={filter.licenses ?? []}
          onChange={(val) => onChangeInternal("licenses", val)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <SelectAccessLevel
          value={filter.accessLevelId}
          onChange={(value) => onChangeInternal("accessLevelId", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <SelectStatusType
          value={filter.statusTypeId}
          onChange={(value) => onChangeInternal("statusTypeId", value)}
        />
      </Grid>
    </CommonFilter>
  );
}
